import {captureException} from '@sentry/browser';

const normalizeError = (error: unknown): Error => {
  if (error instanceof Error) {
    return error;
  }

  if (typeof error === 'object' && error !== null && 'type' in error) {
    const event = error as {type: string; target?: unknown};
    const target = event.target as {url?: string; readyState?: number} | null;
    const url = target?.url ?? 'unknown';
    const readyState = target?.readyState;

    return new Error(`WebSocket ${event.type} event (url: ${url}, readyState: ${readyState})`);
  }

  return new Error(String(error));
};

export const captureWebsocketError = (error: unknown) => {
  const normalizedError = normalizeError(error);
  console.error('AppSync subscription error:', normalizedError.message);
  captureException(normalizedError, {
    tags: {
      module: 'appsync',
    },
    extra: {
      originalError: error,
    },
  });
};
